export const RRS_CREDIT_CHECK_MYSELF = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Hva er en kredittscore?',
  url: 'https://scoopr.no/kredittsjekke-seg-selv',
  description:
    'Enkelt forklart viser dette betalingsevnen din – altså hva du har i gjeld, inntekt og formue, samt om du har noen betalingsanmerkninger.',
  datePublished: '2021-10-22T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
